export { renderAccordion_unstable as renderAccordion } from '@fluentui/react-accordion';
